import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import TaskList from "./TaskList";
import Option from "../../shop/ai/options.jsx";
import Exchange from "./exchange";
import History from './history_main.jsx';
import Orders from "./orders_main";
import Log from "./log";
import Profile from "./profile/main.jsx";
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";

const Coin_home = () => {
    let { slug_1, slug_2, slug_3 } = useParams();
    const latest_version = useSelector(state => state.latest_version);
    
    // Mặc định nếu không có slug thì trỏ về 'orders' (My Cases)
    if (!slug_1 || slug_1 == undefined) {
        slug_1 = 'orders';
    }

    const [pageTitle, setPageTitle] = useState("System Monitor Dashboard");

    // --- LOGIC TITLE ĐÃ "TẨY TRẮNG" (SAFE MODE) ---
    useEffect(() => {
        if (slug_1 === "home") {
            // Cũ: Security Overview -> Mới: System Overview
            setPageTitle("System Overview - Hust Media Platform");
        } 
        else if (slug_2 === "posts") {
            // Cũ: Submit Incident Report -> Mới: Create New Request
            setPageTitle("Create New Data Task");
        } 
        else if (slug_2 === "nhatkyorders") {
            // Cũ: Case Status -> Mới: Workflow Status
            setPageTitle("Workflow Status - My Activities");
        } 
        else if (slug_1 === "lists") {
            if (slug_2 === "search") {
                // Cũ: Entity Lookup -> Mới: Data Query
                setPageTitle("Data Query - Search Engine");
            } else {
                // Cũ: Threat Database -> Mới: Data Registry (Nghe như sổ đăng ký dữ liệu)
                setPageTitle("Data Registry - Global Index");
            }
        } 
        else if (slug_1 === "log") {
            // Cũ: Threat Monitor -> Mới: Performance Monitor
            setPageTitle("System Logs - Real-time Performance Monitor");
        } 
        else {
            // Mặc định
             setPageTitle("System Dashboard - Hust Media");
        }
    }, [slug_1, slug_2]);

    return (
        <>
            {
                slug_1 &&
                (<>
                    <Tabs_nav category={(latest_version == 2 || latest_version == 3) ? 'check_scam_2' : 'check_scam_1'} />
                    <Helmet>
                        <title>{pageTitle}</title>
                        {/* SỬA META DESCRIPTION: Bỏ chữ "Threat detection", đổi thành "Data Automation" */}
                        <meta name="description" content="Hust Media System Monitor - Optimize your digital workflows with AI-powered data automation and real-time monitoring." />
                    </Helmet>

                    {slug_1 === "home" ? (
                        <>
                            <TaskList />
                        </>
                    ) : slug_2 === "posts" ? (
                        <Orders />
                    ) : slug_1 === "lists" ? (
                        (slug_2 === "search" && slug_3 === "home") ? (
                            <Option category="check_search" />
                        ) : (
                            <Exchange />
                        )
                    ) : slug_2 === "nhatkyorders" ? (
                        <>
                        <History />
                        </>
                    ) : slug_1 === "log" ? (
                        <Log />
                    ) : (
                        <Profile onTitleChange={setPageTitle} /> 
                    )}
                </>)
            }
        </>
    );
}

export default Coin_home;